module.exports = "<div style=\"border-color: black\">\r\n  <label>HEADER</label>\r\n</div>\r\n"